import React, { Fragment, useRef } from 'react';
import { Link } from 'react-router-dom';

interface OnboardingSuccessProps {
  submit: () => void;
}

const OnboardingSuccess: React.FC<OnboardingSuccessProps> = ({ submit }) => {
  const buttonRef = useRef(null);

  return (
    <>
      <div className="flex justify-center">
        <div className="w-20 h-20 sm:w-24 sm:h-24 flex items-center justify-center">
          <img
            src="/tada.gif"
            alt="Party Popper"
            className="w-20 h-20 sm:w-24 sm:h-24"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.onerror = null;
              target.innerHTML = '🎉';
            }}
          />
        </div>
      </div>
      <div className="bg-white max-w-lg font-sofiaSans px-4 sm:px-0">
        <div className="text-start">
          <h2 className="text-2xl sm:text-3xl font-bold text-center text-black mb-4 sm:mb-5">You're All Set Up!</h2>
          <div className="mt-2">
            <p className="text-sm text-gray-600 leading-relaxed px-2 mb-3">
              Enjoy this special time with your class. We can't wait to see what you create together.
            </p>
            <p className="text-sm text-gray-600 leading-relaxed px-2 mb-3">
              Once you've added your kids, you can get started by making your first book by clicking "Create New Story"
              on the top right. It's the best way to understand how the process works before your class begins.
            </p>
            <p className="text-sm text-gray-600 leading-relaxed px-2 mb-4">
              If you need anything, we're always here to chat.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-white py-2 flex flex-col sm:flex-row justify-end items-center gap-2 sm:gap-0 px-4 sm:px-0">
        <Link
          to="https://cal.com/ben-spurr-buildmystory/build-my-story-demo"
          target="_blank"
          rel="noopener noreferrer"
          className="flex justify-center items-center text-sm sm:text-base font-sm bg-transparent text-secondaryStoryAdditionalLightBlueText hover:underline rounded-2xl px-6 sm:px-8 py-2 font-bold sm:mr-4 w-full sm:w-auto"
        >
          Book a call with our team
        </Link>
        <button
          className={`px-6 py-2 h-9 bg-secondaryStoryAdditionalLightBlueText text-whiteText font-bold leading-none rounded-2xl hover:shadow-md transition-shadow flex items-center justify-center text-sm sm:text-base w-full sm:w-auto`}
          onClick={() => submit()}
        >
          Continue
        </button>
      </div>
    </>
  );
};

export default OnboardingSuccess;
